<template>
  <div>
    <md-dialog :md-active.sync="show">
      <md-dialog-title>Log In</md-dialog-title>
      <md-dialog-content>
        <p>Coming Soon...</p>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="show = false">Cancel</md-button>
        <md-button class="md-primary" @click="login()">Log In</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "AuthDialog",
  components: {},
  data: () => ({
    show: false
  }),
  methods: {
    showDialog() {
      this.show = true;
    },
    login() {
      this.show = false;
    }
  }
};
</script>

<style scoped>
.md-dialog {
  max-width: 768px;
}
</style>